export interface CompanionTextureSetting {
    id: string | null;
    onlyIfNone?: boolean;
}

interface CompanionTextureIdStore {
    getCompanionTextureId(): string | null;
    setCompanionTextureId(id: string | null): void;
}

interface CompanionTextureIdCache {
    setCompanionTextureId(id: string | null): void;
}

export function applyCompanionTextureSetting(
    setting: CompanionTextureSetting,
    localStore: CompanionTextureIdStore,
    gameManager: CompanionTextureIdStore & CompanionTextureIdCache,
): void {
    if (setting.onlyIfNone === true && gameManager.getCompanionTextureId() !== null) {
        return;
    }

    localStore.setCompanionTextureId(setting.id);
    gameManager.setCompanionTextureId(setting.id);
}
